export default __webpack_public_path__ + "befd9eb8322850589043fe23e0e5785f.svg";